export default __webpack_public_path__ + "static/media/account_circle_grey.176a75d0.svg";